"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwellData = function SwellData() {
  return _react2.default.createElement(
    "div",
    { className: "quiver-intro-modal__item__icon" },
    _react2.default.createElement(
      "svg",
      {
        width: "36px",
        height: "28px",
        viewBox: "0 0 36 28",
        className: "quiver-intro-modal__swell--data--icon"
      },
      _react2.default.createElement(
        "g",
        {
          id: "onboarding-modal",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          transform: "translate(-56.000000, -388.000000)"
        },
        _react2.default.createElement(
          "g",
          {
            id: "Group-8"
          },
          _react2.default.createElement(
            "g",
            {
              id: "Group-2",
              transform: "translate(56.000000, 388.000000)"
            },
            _react2.default.createElement("rect", {
              id: "Rectangle-15",
              fill: "#42A5FC",
              x: "0",
              y: "13",
              width: "11",
              height: "15"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-15-Copy-2",
              fill: "#42A5FC",
              x: "25",
              y: "0",
              width: "11",
              height: "28"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle-15-Copy",
              fillOpacity: "0.5",
              fill: "#96A9B2",
              x: "13",
              y: "6",
              width: "10",
              height: "22"
            })
          )
        )
      )
    )
  );
};

exports.default = SwellData;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/IntroModal/SwellDataIcon.js
// module id = 599
// module chunks = 11